import React from 'react';
import { Stack, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useIntl } from 'react-intl';

import EmptyChatIcon from './EmptyChatIcon';
import { EmptyChatIconBadge, EmptyPanelContent, EmptyPanelHeader } from './StyledComponents';

interface Props {
  onClose: () => void;
}

const EmptyPanel: React.FC<Props> = ({ onClose }) => {
  const { formatMessage } = useIntl();

  return (
    <Stack flex={1} direction="column">
      <EmptyPanelHeader>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </EmptyPanelHeader>
      <EmptyPanelContent>
        <Stack alignItems="center" spacing={2.5}>
          <EmptyChatIconBadge>
            <EmptyChatIcon sx={{ fontSize: 64 }} />
          </EmptyChatIconBadge>
          <Stack alignItems="center" spacing={0.5} sx={{ px: 2.5 }}>
            <Typography
              variant="subtitle1"
              color="text.primary"
              textAlign="center"
              sx={{ fontWeight: 'fontWeightMedium' }}
            >
              {formatMessage({
                id: 'chat.panel.selectChannel',
                defaultMessage: 'Create or select a chat to start messaging',
              })}
            </Typography>
            <Typography variant="body1" color="text.secondary" textAlign="center">
              {formatMessage({
                id: 'chat.panel.selectChannelSubtitle',
                defaultMessage:
                  'Pick a conversation to view messages, share files, and catch up with your team.',
              })}
            </Typography>
          </Stack>
        </Stack>
      </EmptyPanelContent>
    </Stack>
  );
};

export default EmptyPanel;
